module.exports = new __parcel__URL__("spot.36db4a1b.png").toString();